/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{isMars as r,isMoon as t,isWGS84 as e,isCGCS2000 as n}from"../../../geometry/support/spatialReferenceUtils.js";function o(e){return i(e)||r(e)||t(e)}function i(r){return e(r)||n(r)}export{i as isSupportedEarthGCS,o as isSupportedGCSOnGlobe};
